// extracted by mini-css-extract-plugin
export default {"backAnchor":"ContactDetailView_backAnchor__RNMUg","backAnchorIcon":"ContactDetailView_backAnchorIcon__hKp+b"};